import React, { useEffect, useState } from 'react';
import ReactDiffViewer from 'react-diff-viewer-continued';
// import DiffViewer from 'react-diff-viewer';

const diffViewerStyles = {
  variables: {
    dark: {
      diffViewerBackground: '#111827',
      diffViewerColor: '#f8fafc',
      addedBackground: '#0f172a',
      addedColor: '#f8fafc',
      removedBackground: '#111827',
      removedColor: '#f8fafc',
      wordAddedBackground: 'rgba(34, 197, 94, 0.2)',
      wordRemovedBackground: 'rgba(239, 68, 68, 0.2)',
      addedGutterBackground: '#0b1220',
      removedGutterBackground: '#0b1220',
      gutterBackground: '#0b1220',
      gutterBackgroundDark: '#0b1220',
      highlightBackground: 'rgba(78, 188, 228, 0.12)',
      highlightGutterBackground: 'rgba(78, 188, 228, 0.18)',
      codeFoldGutterBackground: '#0b1220',
      codeFoldBackground: '#111827',
      emptyLineBackground: '#111827',
      gutterColor: '#94a3b8',
      addedGutterColor: '#4ade80',
      removedGutterColor: '#f87171',
      codeFoldContentColor: '#cbd5e1'
    }
  },
  diffContainer: {
    borderRadius: '0.9rem',
    overflow: 'hidden',
    border: '1px solid #334155',
    boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.02)'
  },
  splitView: {
    gap: '1.5rem'
  },
  titleBlock: {
    background: '#0b1220',
    borderBottom: '1px solid #334155',
    color: '#f8fafc',
    padding: '0.9rem 1rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.04em'
  },
  contentText: {
    color: '#f8fafc',
    fontFamily: 'monospace'
  },
  line: {
    color: '#f8fafc',
    fontFamily: 'monospace'
  },
  gutter: {
    color: '#94a3b8'
  },
  marker: {
    color: '#cbd5e1'
  }
};

function FilesDiff({ differences, leftTitle, rightTitle }) {
  const [leftText, setLeftText] = useState('');
  const [rightText, setRightText] = useState('');

  useEffect(() => {
    if (differences) {
      if (differences.length > 0) {
        const leftText = differences.filter(d => !d.removed).map(d => d.value).join('');
        const rightText = differences.filter(d => !d.added).map(d => d.value).join('');
        setLeftText(leftText);
        setRightText(rightText);
      }
    }
    else {
      setLeftText('');
      setRightText('');
    }
  }, [differences]);

  //this a code from the 'react-diff-viewer-continued' library documentation
  // class Diff extends PureComponent {
  //   render = () => {
  //     return (
  //       <ReactDiffViewer oldValue={oldCode} newValue={newCode} splitView={true} />
  //     );
  //   };
  // }

  return (
    <div className="oct_diff-container-v2">
      {(leftText || rightText) ? (
        <ReactDiffViewer oldValue={leftText}
          newValue={rightText}
          splitView={true}
          useDarkTheme={true}
          styles={diffViewerStyles}
          leftTitle={leftTitle}
          rightTitle={rightTitle} />
      ) : (
        <div className="oct_diff-grid-v2">
          {/* File 1 */}
          <div>
            <h3 className="oct_diff-file-label-v2">{leftTitle}</h3>
            <div className="oct_diff-file-panel-v2">
              <p className="oct_diff-file-placeholder-v2">Configuration file content will be displayed here...</p>
            </div>
          </div>

          {/* File 2 */}
          <div>
            <h3 className="oct_diff-file-label-v2">{rightTitle}</h3>
            <div className="oct_diff-file-panel-v2">
              <p className="oct_diff-file-placeholder-v2">Configuration file content will be displayed here...</p>
            </div>
          </div>
        </div>
      )}
    </div>
  )

}

export default FilesDiff;
